import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { HeaderTabs } from './shared';

export type GiftVoucherModuleFooterProps = {
    activeTab: HeaderTabs;
};

const GiftVoucherModuleFooter = ({ activeTab }: GiftVoucherModuleFooterProps) => {
    const { t } = useTranslation(['giftVoucherModuleDetails']);

    const formName = activeTab === HeaderTabs.MainDetails ? 'updateMainDetails' : 'updateEmailContent';

    return (
        <Button form={formName} htmlType="submit" type="primary">
            {t('giftVoucherModuleDetails:actions.update')}
        </Button>
    );
};

export default GiftVoucherModuleFooter;
